module.exports = __webpack_public_path__ + "img/ENI_120X35.4f021ffa.png";